import {
  API_CALL,
  REQUEST_ORDER,
  RECEIVE_ORDER,
  SAVE_ORDER,
  ORDER_FAILED,
  ADD_PLACEMENTS_TO_ORDER,
  UPDATE_PLACEMENTS_IN_ORDER,
  REQUEST_CLONE_ORDER,
  RECEIVE_CLONE_ORDER,
  CLONE_ORDER_FAILED,
  REQUEST_PUSH_ORDER,
  RECEIVE_PUSH_ORDER,
  PUSH_ORDER_FAILED,
  REQUEST_UNLOCK_ORDER,
  RECEIVE_UNLOCK_ORDER,
  UNLOCK_ORDER_FAILED,
  REQUEST_PUT_ORDER,
  RECEIVE_PUT_ORDER,
  PUT_ORDER_FAILED,
  DELETE_ORDER,
  RECEIVE_DELETED_ORDER,
  REQUEST_CHANGELOG,
  RECEIVE_CHANGELOG,
  CHANGELOG_FAILED,
  UPDATE_INLINE_PLACEMENT,
  SELECT_ATTACHMENT,
  UPLOAD_ATTACHMENT,
  RECEIVE_ATTACHMENT,
  UPLOAD_FAILED,
  LIST_ATTACHMENTS,
  RECEIVE_ATTACHMENTS,
  LIST_ATTACHMENTS_FAILED,
  DELETE_ATTACHMENT,
  ATTACHMENT_DELETED,
  RESTORE_ORDER,
  ORDER_RESTORED,
  ORDER_NOT_RESTORED,
  REQUEST_RELAX_ORDER,
  RECEIVE_RELAX_ORDER,
  RELAX_ORDER_FAILED
} from './types';

import { hasError } from './actionHelpers';
import { clonePlacements, pushPlacements, setEditList } from "./placementActions";
import {toast} from "react-toastify";

export const setOrder = order => ({
  type: RECEIVE_ORDER,
  order
});

export const getOrder = orderId => ({
  type: API_CALL,
  onRequest: REQUEST_ORDER,
  onResponse: RECEIVE_ORDER,
  onError: ORDER_FAILED,
  responseKey: 'order',
  payload: {
    method: 'GET',
    url: `/ios/${orderId}`
  },
  orderId
});

export const saveOrder = (id, order) => ({
  type: API_CALL,
  onRequest: SAVE_ORDER,
  onResponse: RECEIVE_ORDER,
  onError: ORDER_FAILED,
  responseKey: 'order',
  payload: {
    method: 'POST',
    url: id ? `/ios/${id}` : '/ios',
    data: order
  },
  order
});

export const saveOrderAndNotify = (id, order, history) => (dispatch, getState) => {
  const infoMsg = `Saving Order ${order.id || ''}`;
  toast.info(infoMsg, { theme: 'colored', toastId: infoMsg });
  return dispatch(saveOrder(id, order)).then(() => {
    const err = hasError(getState(), 'orderRequest', dispatch);
    if (err) {
      toast.error(err, { theme: 'colored', toastId: err });
      return;
    }
    const { order } = getState().orderRequest;
    const successMessage = `Successfully saved order ${order.id}`;
    toast.success(successMessage, { theme: 'colored', toastId: successMessage });
    dispatch(setOrder(order));
    history.push(`/ios/${order.id}/refresh`);
  });
};

export const addPlacementsToOrder = (order, placementsToAdd) => ({
  type: ADD_PLACEMENTS_TO_ORDER,
  order,
  placements: placementsToAdd
});

export const updateFromAM = (orderId) => ({
  type: API_CALL,
  onRequest: REQUEST_PUT_ORDER,
  onResponse: RECEIVE_PUT_ORDER,
  onError: PUT_ORDER_FAILED,
  payload: {
    method: 'PUT',
    url: '/ios/updateFromAM',
    data: { orderId: orderId }
  }
});

export const relaxEdits = (orderId) => ({
  type: API_CALL,
  onRequest: REQUEST_RELAX_ORDER,
  onResponse: RECEIVE_RELAX_ORDER,
  onError: RELAX_ORDER_FAILED,
  payload: {
    method: 'PUT',
    url: '/ios/relaxEdits',
    data: { orderId: orderId }
  }
});

export const setToNeedsUpdate = (orderId) => ({
  type: API_CALL,
  onRequest: REQUEST_PUT_ORDER,
  onResponse: RECEIVE_PUT_ORDER,
  onError: PUT_ORDER_FAILED,
  payload: {
    method: 'PUT',
    url: '/ios/setToNeedsUpdate',
    data: { orderId: orderId }
  }
});

export const setToUpdated = (orderId) => ({
  type: API_CALL,
  onRequest: REQUEST_PUT_ORDER,
  onResponse: RECEIVE_PUT_ORDER,
  onError: PUT_ORDER_FAILED,
  payload: {
    method: 'PUT',
    url: '/ios/setToUpdated',
    data: { orderId: orderId }
  }
});

export const pushPlacementsAndUpdateOrder = (orderId, placementsToPush, pushRules, history) => (dispatch, getState) => {
  console.log('push placements and update order', placementsToPush);
  let infoMsg = (pushRules.includes('soapLog')) ? `Pushing placements with SOAP log` : `Pushing placements`;
  toast.info(infoMsg, { theme: 'colored', toastId: infoMsg });
  dispatch(pushPlacements(orderId, placementsToPush, pushRules))
    .then((/* dispatched */) => {
      const { pushResult } = getState().placementRequest;
      if (pushResult && pushResult.error) {
        toast.error(pushResult.error, { theme: 'colored', toastId: pushResult.error });
      } else if (!pushResult || !pushResult.placements) {
        const err = 'Order has no push result.'
        toast.error(err, { theme: 'colored', toastId: err });
      } else if (pushResult.pushed === 0) {
        const err = 'No placements could be pushed';
        toast.error(err, { theme: 'colored', toastId: err });
      } else if (pushResult.direct) {
        infoMsg = `Placements pushed to GAM: ${pushResult.placements.length || 1}`;
        toast.success(infoMsg, { theme: 'colored', toastId: infoMsg });
        setTimeout(history.push, 1000,`/ios/${orderId}/refresh`);
      } else {
        infoMsg = `Placements being pushed to GAM: ${(pushResult.placements) ? pushResult.placements.length : 1}`;
        toast.info(infoMsg, { theme: 'colored', toastId: infoMsg });
      }
    });
};

export const clonePlacementsAndUpdateOrder = (order, placementsToClone, times) => (dispatch, getState) => {
  const infoMsg = `Cloning ${placementsToClone.length} Placements ${times} times`;
  toast.info(infoMsg, { theme: 'colored', toastId: infoMsg });
  return dispatch(clonePlacements(placementsToClone, times)).then((/* dispatched */) => {
    const err = hasError(getState(), 'placementRequest', dispatch);
    if (err) {
      toast.error(err, { theme: 'colored', toastId: err });
      return;
    }
    dispatch(addPlacementsToOrder(order, getState().placementRequest.clonedPlacements));
    const ids = order.Placements.map(p => p.id);
    const ids2 = getState().placementRequest.clonedPlacements.map(cp => cp.id);
    dispatch(setEditList(ids.concat(ids2)));
    const { clonedPlacements } = getState().placementRequest;
    const successMessage = `Successfully cloned ${clonedPlacements.length} Placements`;
    toast.success(successMessage, { theme: 'colored', toastId: successMessage });
    });
};

export const deleteOrder = id => ({
  type: API_CALL,
  onRequest: DELETE_ORDER,
  onResponse: RECEIVE_DELETED_ORDER,
  onError: ORDER_FAILED,
  payload: {
    method: 'DELETE',
    url: `/ios/${id}`
  }
});

const localUpdatePlacement = placement => ({
  type: UPDATE_PLACEMENTS_IN_ORDER,
  placements: [placement]
});

const remoteUpdatePlacement = placement => ({
  type: API_CALL,
  onRequest: UPDATE_INLINE_PLACEMENT,
  onResponse: UPDATE_PLACEMENTS_IN_ORDER,
  onError: ORDER_FAILED,
  payload: {
    method: 'POST',
    url: `/placements/${placement.id}`,
    data: placement
  },
  responseKey: 'placements',
  placements: [placement]
});

export const updatePlacement = (placement, done) => (dispatch, getState) => {
  if (!done) {
    dispatch(localUpdatePlacement(placement));
    return;
  }
  const infoMsg = `Updating placement ${placement.id}`
  toast.info(infoMsg, { theme: 'colored', toastId: infoMsg });
  dispatch(remoteUpdatePlacement(placement))
  .then(() => {
    const err = hasError(getState(), 'orderRequest', dispatch);
    if (err) {
      toast.error(err, { theme: 'colored', toastId: err });
      return;
    }
    const successMessage = `Saved placement ${placement.id}`
    toast.success(successMessage, { theme: 'colored', toastId: successMessage });
  })
};

export const getChangeLog = orderId => ({
  type: API_CALL,
  onRequest: REQUEST_CHANGELOG,
  onResponse: RECEIVE_CHANGELOG,
  onError: CHANGELOG_FAILED,
  responseKey: 'changelog',
  payload: {
    method: 'GET',
    url: `/ios/${orderId}/changelog`
  }
});

export const cloneOrder = (order, newIOSettings) => ({
  type: API_CALL,
  onRequest: REQUEST_CLONE_ORDER,
  onResponse: RECEIVE_CLONE_ORDER,
  onError: CLONE_ORDER_FAILED,
  payload: {
    method: 'POST',
    url: `/ios/${order.id}/clone`,
    data: {
      cloneFrom: order,
      newIO: newIOSettings
    }
  }
});

export const cloneOrderWithNotifications = (order, newIOSettings, history) =>
  (dispatch, getState) => {
  const infoMsg = `Cloning new IO from ${order.id}`;
  toast.info(infoMsg, { theme: 'colored', toastId: infoMsg });
  return dispatch(cloneOrder(order, newIOSettings)).then((/* dispatched */) => {
    const err = hasError(getState(), 'orderRequest', dispatch);
    if (err) {
      toast.error(err, { theme: 'colored', toastId: err });
      return;
    }
    const newOrderId = getState().orderRequest.clonedOrder.id;
    const successMessage = `Clone successful, new Order is ${newOrderId}`;
    toast.success(successMessage, { theme: 'colored', toastId: successMessage });
    history.push(`/ios/${newOrderId}`);
    dispatch(getOrder(newOrderId));
  });
};

export const pushOrder = (orderId, pushRules) => ({
  type: API_CALL,
  onRequest: REQUEST_PUSH_ORDER,
  onResponse: RECEIVE_PUSH_ORDER,
  onError: PUSH_ORDER_FAILED,
  payload: {
    method: 'POST',
    url: `/ios/${orderId}/push`,
    data: { pushRules: pushRules }
  }
});

export const pushOrderWithNotifications = (orderId, pushRules)  => (dispatch, getState) => {
  let infoMsg = `Will push order ${orderId} to GAM`;
  if (pushRules.length > 0) {
    if (pushRules[0][0] === 'selectAll') {
      infoMsg += ` [rules: 'selectAll']`;
    } else {
      infoMsg += ` [rules: ${pushRules.join(',')}]`;
    }
  }
  toast.info(infoMsg, { theme: 'colored', toastId: infoMsg });
  dispatch(pushOrder(orderId, pushRules)).then(() => {
    const state = getState();
    const { error, pushResult } = state.orderRequest;
    if (error) {
      const err = hasError(state, 'orderRequest', dispatch);
      if (err) {
        toast.error(err, { theme: 'colored', toastId: err });
      }
      return;
    }
    if (pushResult.Error) {
      toast.error(pushResult.Error, { theme: 'colored', toastId: pushResult.Error });
      return;
    }
    if (pushResult.Errors > 0) {
      const warnMsg = `Order ${orderId} pushed ${pushResult.Pushed} line items to GAM with ${pushResult.Errors} errors`;
      toast.warn(warnMsg, { theme: 'colored', toastId: warnMsg });
    }
    if (pushResult.Pushed === 0) {
      const warnMsg = `Order ${orderId} No line items to push to GAM`;
      toast.warn(warnMsg, { theme: 'colored', toastId: warnMsg });
    } else if (pushResult['Direct']) {
      infoMsg = `Order ${orderId} ${pushResult['Pushed']} line items pushed to GAM`;
      toast.success(infoMsg, { theme: 'colored', toastId: infoMsg });
    } else {
      infoMsg = `Order ${orderId} ${pushResult['Pushed']} line items being pushed to GAM`;
      toast.info(infoMsg, { theme: 'colored', toastId: infoMsg });
    }
  });
};

export const unlockOrder = (orderId) => ({
  type: API_CALL,
  onRequest: REQUEST_UNLOCK_ORDER,
  onResponse: RECEIVE_UNLOCK_ORDER,
  onError: UNLOCK_ORDER_FAILED,
  payload: {
    method: 'POST',
    url: `/ios/unlock`,
    data: { orderId: orderId }
  }
});

export const selectAttachment = attachment => ({
  type: SELECT_ATTACHMENT,
  attachment
});

export const uploadAttachment = (orderId, file, name) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("name", name);
  return {
    type: API_CALL,
    onRequest: UPLOAD_ATTACHMENT,
    onResponse: RECEIVE_ATTACHMENT,
    onError: UPLOAD_FAILED,
    responseKey: 'attachment',
    payload: {
      method: 'PUT',
      url: `/ios/${orderId}/attachments`,
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    }
  }
}

export const listAttachments = (orderId) => ({
  type: API_CALL,
  onRequest: LIST_ATTACHMENTS,
  onResponse: RECEIVE_ATTACHMENTS,
  onError: LIST_ATTACHMENTS_FAILED,
  responseKey: 'attachments',
  payload: {
    method: 'GET',
    url: `/ios/${orderId}/attachments`
  }
})

export const deleteAttachment = (orderId, attachmentId) => ({
  type: API_CALL,
  onRequest: DELETE_ATTACHMENT,
  onResponse: ATTACHMENT_DELETED,
  responseKey: 'attachments',
  payload: {
    method: 'DELETE',
    url: `/ios/${orderId}/attachments/${attachmentId}`
  }
})

export const restoreDeletedOrder = (orderId) => ({
  type: API_CALL,
    onRequest: RESTORE_ORDER,
    onResponse: ORDER_RESTORED,
    onError: ORDER_NOT_RESTORED,
    payload: {
      method: 'POST',
      url: `/ios/restoreDeletedOrder`,
      data: { orderId: orderId }
  }
})
